<template>
  <div class="buddycomcall-record-list-root">
    <div
      id="record-list-field"
      v-if="!showDetail || isCallRecordDisplayFixEnabled"
      class="buddycomcall-record-list-panel"
    >
      <div v-if="!displayInitialNotice" class="object-titlebox">
        <div class="object-titlebox-right" style="padding-top: 10px; padding-bottom: 10px">
          <span v-if="isCallRecordDisplayFixEnabled" class="buddycomcall-record-count">
            {{ $t("message.item_talk_call_record_count", { count: talkrecords.length }) }}
          </span>
          <!-- 更新ボタン -->
          <button class="transparent-button" type="button" v-on:click="refreshList()">
            <img src="../../assets/icon_load.svg" />
            <span class="normal-command-text" v-t="'message.action_talk_refresh'"></span>
          </button>
        </div>
      </div>
      <div class="buddycomcall-table-wrap">
        <el-table
          ref="talkRecordsTable"
          :key="tableRenderKey"
          v-loading="loading"
          element-loading-text="Loading..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          :empty-text="getEmptyTalkRecordText()"
          :show-header="!displayInitialNotice"
          :row-class-name="checkHiddenData"
          :data="talkrecords"
          :default-sort="{ prop: 'activateTime', order: 'ascending' }"
          :highlight-current-row="true"
          @row-click="onRowClick"
          height="100%"
          style="width: 100%"
          header-row-class-name="talkrecord-header"
        >
          <!-- prop="activateTime" とは、talkrecords の要素を使うという意味 -->
          <!-- 開始時刻 -->
          <el-table-column
            prop="activateTime"
            :label="$t('message.item_talk_start_datetime')"
            sortable
            min-width="200"
          >
            <template slot-scope="scope">
              {{ getStartDate(scope.row) ? getStartDate(scope.row).toLocaleString() : "－" }}
            </template>
          </el-table-column>

          <!-- 発話者  -->
          <el-table-column
            :label="$t('message.item_talk_call_talker')"
            prop="requesterDisplayName"
            sortable
            :sort-method="sortByDisplayName"
            header-align="left"
            align="left"
            min-width="200"
          >
            <template slot-scope="scope">
              <span v-if="getDisplayName(scope.row)">
                <span v-if="getDisplayName(scope.row).length <= 8">{{
                  getDisplayName(scope.row)
                }}</span>
                <span v-else>{{ getDisplayName(scope.row).substring(0, 50) }}...</span>
              </span>
            </template>
          </el-table-column>

          <!-- 通話時間  -->
          <el-table-column
            :label="$t('message.item_talk_time')"
            prop="endTime"
            header-align="left"
            align="left"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="getDurationMs(scope.row) != null">
                {{ convertCallTime(getDurationMs(scope.row)) }}
              </span>
              <span v-else>－</span>
            </template>
          </el-table-column>

          <!-- 詳細  -->
          <el-table-column
            :label="$t('message.action_talk_detail')"
            header-align="center"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <button class="item-record-button">
                <img src="../../assets/icon_arrow_blue.svg" />
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <line-like-chat
      v-if="showDetail"
      :class="{ 'buddycomcall-record-detail-overlay': isCallRecordDisplayFixEnabled }"
      :partner="detailPartner"
      :self-label="detailSelfLabel"
      :messages="detailMessages"
      @close="showDetail = false"
    />
  </div>
</template>

<script>
import server from "../ServerApi.js";
import TalkrecordDetail from "../talk/TalkrecordDetail.vue";
import constants from "@/components/constants.js";
import commonUtil from "@/components/commonutil.js";
import LineLikeChat from "./BuddycomCallTalkRecordDetail.vue";
import { FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY } from "@/components/feature_toggles/feature_toggle";

export default {
  data() {
    return {
      notSupportAgent: false,
      talkrecords: [],
      showDetail: false,
      detailShownRecord: null,
      languageList: null,
      selectedLanguageIndex: 0,
      timer: null,
      loading: false,
      displayInitialNotice: true,
      lastClickedRecord: null,
      tableRenderKey: 0,
    };
  },
  methods: {
    initTalkRecordListPanel: function () {
      this.currentPlayingButton = null;
      this.languageList = commonUtil.getLanguageIndexList(this.$i18n.locale);
      this.selectedLanguageIndex = this.languageIndex;
      this.displayInitialNotice = true;
    },
    getList: function (refresh) {
      if (this.selected.length === 0) {
        this.talkrecords = [];
        return;
      }

      if (!this.isTalkgroup && this.selected.length !== 2) {
        this.talkrecords = [];
        return;
      }

      let self = this;

      let rangeMs = this.toDateTime.getTime() - this.fromDateTime.getTime();
      if (rangeMs < 0 || rangeMs > 24 * 60 * 60 * 1000) {
        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_talk_search_range_over_24h"));
        this.talkrecords = [];
        return;
      }

      let utcFromDateStr = this.fromDateTime.toISOString();
      let utcToDateStr = this.toDateTime.toISOString();

      let endpoint;
      let input;

      this.loading = true;
      this.displayInitialNotice = false;

      endpoint = "/getbuddycomcalltalkrecords";
      input = {
        talkgroupId: this.selected[0].data.id,
        fromDate: utcFromDateStr,
        toDate: utcToDateStr,
        interestLanguageIndex: this.selectedLanguageIndex,
      };

      server
        .post(endpoint, input)
        .then((res) => {
          switch (res.data.status) {
            case constants.STATUS_SUCCESS:
              this.talkrecords = this.mergeTalkrecords(res.data.buddycomCallRecords);
              if (FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY) {
                // 初期表示時はヘッダーが非表示のため、行数確定後に再生成して高さを再計算する。
                this.tableRenderKey += 1;
              }
              self.setTimer();
              break;
            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
              this.talkrecords = [];
              commonUtil.notifyMessage(
                self,
                "Success",
                commonUtil.getMessageText(self.$i18n, "info_refresh_talk_list")
              );
              self.loading = false;
              break;
            default:
              commonUtil.notifyMessage(
                self,
                "Error",
                commonUtil
                  .getMessageText(self.$i18n, "error_server_api")
                  .replace("{functionName}", "getList")
                  .replace("{code}", res.data.status)
              );
              self.loading = false;
              return;
          }
          if (refresh) {
            commonUtil.notifyMessage(
              self,
              "Success",
              commonUtil.getMessageText(self.$i18n, "info_refresh_talk_list")
            );
          }
        })
        .catch(function (error) {
          self.loading = false;
          commonUtil.putExceptionErrorMessage(self, "getList", error);
        });
    },
    // 行クリックで発話を取りに行く
    onRowClick(row) {
      if (!row || this.loading) return;
      this.lastClickedRecord = row;
      this.fetchUtterancesAndOpen(row);
    },

    // クリック行から発話を取得→LINEビューへ遷移
    fetchUtterancesAndOpen(talkrecord) {
      const endpoint = "/getbuddycomcallutterance";
      const input = { requestId: talkrecord.requestId };

      this.loading = true;
      this.lastClickedRecord = talkrecord; // 相手名などに使う

      server
        .post(endpoint, input)
        .then((res) => {
          if (res.data.status === constants.STATUS_SUCCESS) {
            // 取得した utterances 配列を保存
            // TODO: 現在親機は日本語のみ対応なので、ハードコードで日本語でフィルタ（子機が日本語以外の場合、その日本語への翻訳結果のみ表示）
            // 親機を多言語対応する際に修正する
            if (res.data.buddycomCallUtterances) {
              this.detailShownRecord = res.data.buddycomCallUtterances.filter(
                (utterance) => utterance.languageIndex === 1
              );
            } else {
              this.detailShownRecord = [];
            }
            // LINE 画面へ切り替え
            this.showDetail = true;
          } else if (res.data.status === constants.STATUS_ERROR_OBJECT_NOT_FOUND) {
            commonUtil.notifyMessage(
              this,
              "Warning",
              commonUtil.getMessageText(this.$i18n, "info_no_talk_record_list")
            );
          } else {
            commonUtil.notifyMessage(
              this,
              "Error",
              commonUtil
                .getMessageText(this.$i18n, "error_server_api")
                .replace("{functionName}", "fetchUtterancesAndOpen")
                .replace("{code}", res.data.status)
            );
          }
        })
        .catch((error) => {
          commonUtil.putExceptionErrorMessage(this, "fetchUtterancesAndOpen", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refreshList: function () {
      return this.getList(false);
    },
    mergeTalkrecords(buddycomCallRecords) {
      const mergedBuddycomCallRecords = [];

      if (!Array.isArray(buddycomCallRecords) || buddycomCallRecords.length === 0) {
        return mergedBuddycomCallRecords;
      }

      for (let i = 0; i < buddycomCallRecords.length; i++) {
        const r = buddycomCallRecords[i];
        // FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAYの修正適用後はBEでフィルタされるため不要
        if (!FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY) {
          // activateTime が存在しない( null / undefined / '' )ものはスキップ
          if (!r.activateTime) {
            continue;
          }
        }

        mergedBuddycomCallRecords.push({
          id: r.id,
          requestId: r.requestId,
          createTime: r.createTime ? new Date(r.createTime) : null,
          activateTime: r.activateTime ? new Date(r.activateTime) : null,
          endTime: r.endTime ? new Date(r.endTime) : null,
          requesterUserId: r.requesterUserId,
          requesterDisplayName: r.requesterDisplayName,
          requesterLanguage: r.requesterLanguage,
          requesterUserType: r.requesterUserType,
          responderUserId: r.responderUserId,
          responderDisplayName: r.responderDisplayName,
          responderLanguage: r.responderLanguage,
          responderUserType: r.responderUserType,
        });
      }

      return mergedBuddycomCallRecords;
    },
    getEmptyTalkRecordText() {
      if (this.displayInitialNotice) {
        return " ";
      }
      if (this.selected === null || this.selected.length === 0) {
        return commonUtil.getMessageText(this.$i18n, "info_please_select_group");
      } else {
        if (this.isTalkgroup) {
          return commonUtil.getMessageText(this.$i18n, "info_group_talk_not_found");
        } else {
          if (this.selected.length < 2) {
            return commonUtil.getMessageText(this.$i18n, "info_please_select_talkers");
          } else {
            return commonUtil.getMessageText(this.$i18n, "info_individual_talk_not_found");
          }
        }
      }
    },
    checkHiddenData({ row }) {
      if (row.hidden) {
        return "hiddenData-row";
      } else {
        return "showData-row";
      }
    },
    isVideo(type, data) {
      return commonUtil.isVideo(type, data);
    },
    isImage(type, data) {
      return commonUtil.isImage(type, data);
    },
    getDisplayDatetime(utcTime) {
      commonUtil.getFormattedLocalDatetime(utcTime);
    },
    closeLoadingScreen() {
      if (this.loadingScreen != null) {
        this.loadingScreen.close();
        this.loadingScreen = null;
      }
    },
    checkTalkRecordList() {
      if (this.$refs.talkRecordsTable.data.length === this.talkrecords.length) {
        clearInterval(this.timer);
        this.timer = null;
        this.loading = false;
        commonUtil.notifyMessage(
          this,
          "Success",
          commonUtil.getMessageText(this.$i18n, "info_refresh_talk_list")
        );
      }
    },
    setTimer: function () {
      if (this.timer != null) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.timer = setInterval(this.checkTalkRecordList, 100);
    },
    convertCallTime: function (duration) {
      return FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY
        ? commonUtil.convertMillisecondToHMS(duration)
        : commonUtil.convertMillsec(duration);
    },
    getDisplayName(row) {
      return row.requesterDisplayName || row.responderDisplayName || "";
    },
    getResponderDisplayName(row) {
      return row.responderDisplayName || row.requesterDisplayName || "";
    },
    getCallRecordParticipants(record) {
      // requester/responder は通話開始順であり、左右の表示位置には使用しない。
      return [
        {
          userId: record.requesterUserId,
          userType: record.requesterUserType,
          displayName: record.requesterDisplayName,
        },
        {
          userId: record.responderUserId,
          userType: record.responderUserType,
          displayName: record.responderDisplayName,
        },
      ];
    },
    getParticipantByUserId(record, userId) {
      return this.getCallRecordParticipants(record).find(
        (participant) => participant.userId != null && String(participant.userId) === String(userId)
      );
    },
    getParticipantDisplayName(record) {
      const participant = this.getCallRecordParticipants(record).find(
        (candidate) => candidate.userType === constants.OBJECT_BUDDYCOM_CALL_USER
      );
      return participant?.displayName || "";
    },
    getStartDate(row) {
      if (row && (row.activateTime || row.createTime)) {
        return new Date(row.activateTime || row.createTime);
      }
      return null;
    },
    getDurationMs(row) {
      const start = this.getStartDate(row);
      const end = row && row.endTime ? new Date(row.endTime) : null;
      if (start && end) return end - start;
      return null;
    },
    sortByDisplayName(a, b) {
      const da = this.getDisplayName(a).toLowerCase();
      const db = this.getDisplayName(b).toLowerCase();
      if (da < db) return -1;
      if (da > db) return 1;
      return 0;
    },
  },
  watch: {
    dateRangeKey: {
      handler() {
        return this.getList(false);
      },
    },
    selected: {
      handler() {
        return this.getList(false);
      },
    },
    languageIndex: {
      handler(newVal) {
        this.selectedLanguageIndex = newVal;
        return this.getList(false);
      },
    },
    $route(to) {
      if (to.name === "Call") {
        this.initTalkRecordListPanel();
      }
    },
  },
  computed: {
    isCallRecordDisplayFixEnabled() {
      return FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY;
    },
    // fromDateTime/toDateTimeは日時レンジピッカー(1コントロール)の値なので同時に変わる。
    // 別々のwatcherにすると1回の変更でgetList()が2回走ってしまうため、1つの値にまとめて単一のwatcherにする
    dateRangeKey() {
      return this.fromDateTime.getTime() + '_' + this.toDateTime.getTime();
    },
    // 相手(画面左側に表示するバブル)情報（一覧でクリックした行から名前などを拝借）
    detailPartner() {
      const record = this.lastClickedRecord || {};
      const name = FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY
        ? this.getParticipantDisplayName(record) || "相手"
        : this.getDisplayName(record) || "相手";
      return { name, status: "" };
    },
    // 自分(画面右側に表示するバブル)情報（一覧でクリックした行から名前などを拝借）
    detailSelfLabel() {
      const record = this.lastClickedRecord || {};
      if (FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY) {
        // requesterとresponderのうち、CallUserでない方を右側に表示する
        return record.requesterUserType === constants.OBJECT_BUDDYCOM_CALL_USER
          ? record.responderDisplayName
          : record.requesterDisplayName;
      } else {
        // 自分側に表示したい名前だけ返す
        return this.getResponderDisplayName(record);
      }
    },
    // utterances → LineLikeChat の messages 形式に変換
    detailMessages() {
      const recordArray = Array.isArray(this.detailShownRecord) ? this.detailShownRecord : [];

      if (FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY) {
        const record = this.lastClickedRecord;
        if (!record) return [];
        return recordArray.map((utterance, index) => {
          const participant = this.getParticipantByUserId(record, utterance.userId);
          return {
            id: index + 1,
            // Call ユーザー（子機）は左、それ以外（親機）は右に固定する。
            from: participant?.userType === constants.OBJECT_BUDDYCOM_CALL_USER ? "other" : "me",
            text: utterance.text || "",
            at: utterance.startTime
              ? new Date(utterance.startTime)
              : utterance.endTime
                ? new Date(utterance.endTime)
                : "",
          };
        });
      } else {
        // 1) 自分の userId が取れるなら厳密判定（例: this.appData.userId）
        const myUserId =
          this.appData && this.appData.userId != null
            ? this.appData.userId
            : this.$store &&
                this.$store.state &&
                this.$store.state.user &&
                this.$store.state.user.id != null
              ? this.$store.state.user.id
              : null;

        if (myUserId != null) {
          return recordArray.map((u, i) => ({
            id: i + 1,
            from: u.userId === myUserId ? "me" : "other",
            text: u.text || "",
            at: u.startTime ? new Date(u.startTime) : u.endTime ? new Date(u.endTime) : new Date(),
          }));
        }

        // 2) 自分の userId が無い場合のフォールバック（先に出てきた2人を other/me に割当）
        const roleByUser = new Map();
        let first = null,
          second = null;
        for (const u of recordArray) {
          if (u && u.userId != null && !roleByUser.has(u.userId)) {
            if (first == null) {
              first = u.userId;
              roleByUser.set(u.userId, "other");
            } else if (second == null) {
              second = u.userId;
              roleByUser.set(u.userId, "me");
            } else {
              roleByUser.set(u.userId, "other");
            } // 3人目以降は other 扱い（必要に応じて調整）
          }
        }

        return recordArray.map((u, i) => ({
          id: i + 1,
          from: roleByUser.get(u.userId) || "other",
          text: u.text || "",
          at: u.startTime ? new Date(u.startTime) : u.endTime ? new Date(u.endTime) : new Date(),
        }));
      }
    },
  },
  created() {
    this.currentPlayingButton = null;
    let userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("msie") > 0 || userAgent.indexOf("trident") > 0) {
      this.notSupportAgent = true;
    }
    this.languageList = commonUtil.getLanguageIndexList(this.$i18n.locale);
    this.selectedLanguageIndex = this.languageIndex;
  },
  mounted() {
    // Ensure initial load when the tab/content is first rendered
    this.initTalkRecordListPanel();
    this.getList(false);
  },
  components: {
    LineLikeChat,
    TalkrecordDetail,
  },
  props: ["appData", "fromDateTime", "toDateTime", "languageIndex", "selected", "isTalkgroup"],
};
</script>

<style>
tr.talkrecord-header > th {
  color: #848991;
  font-size: 12px;
  background-color: #f6f6f6;
  padding-top: 0;
  padding-bottom: 0;
}
tr.hiddenData-row {
  background: #cfcfcf;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: unset;
}
tr.hiddenData-row {
  background: #dddddd;
}
tr.hiddenData-row:hover {
  background-color: #cfcfcf;
}
tr.showData-row {
  background: #ffffff;
}
tr.showData-row:hover {
  background-color: #ecf1fa;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.buddycomcall-record-list-root {
  position: relative;
  height: 100%;
  min-height: 0;
  min-width: 0;
}

.buddycomcall-record-detail-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  background-color: #ffffff;
}

.buddycomcall-record-count {
  margin-right: 12px;
  color: #848991;
  font-size: 12px;
  vertical-align: middle;
}

.buddycomcall-record-list-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  min-width: 0;
}

.buddycomcall-table-wrap {
  flex: 1;
  min-height: 0;
  min-width: 0;
  padding-bottom: 14px;
  box-sizing: border-box;
}

.buddycomcall-table-wrap >>> .el-table {
  height: 100% !important;
}

table {
  border-collapse: collapse;
}
tr.talk-record {
  border-bottom: 1px solid #eee;
}
tr.talk-record {
  border-bottom: solid;
  border-width: 1px;
  border-color: #eee;
  padding-left: 20px;
}
td.record-starttime {
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
td.record-displayname {
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
td.record-data {
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.object-titlebox-right >>> .el-select .el-input {
  font-size: 12px;
  width: 130px;
}
.object-titlebox-right >>> .el-input__inner {
  height: 30px;
}
.object-titlebox-right >>> .el-input__icon {
  line-height: 30px;
}
.el-table:before {
  background-color: #ffffff;
}
.el-table >>> .cell {
  word-break: normal;
}
</style>
